const isTruthy = (v) => !!v;
export {isTruthy};